import React from "react";
import { Check, Download, ShoppingBag, Briefcase, Printer } from "lucide-react";
import { Card } from "@components";

interface PaymentSuccessProps {
    orderNumber?: string;
    invoiceUrl?: string;
    onDownload?: () => void;
    onPrint?: () => void;
    onShopRedirect?: () => void;
    onSellingManagementRedirect?: () => void;
}

export const PaymentSuccess: React.FC<PaymentSuccessProps> = ({
    orderNumber,
    invoiceUrl,
    onDownload,
    onPrint,
    onShopRedirect,
    onSellingManagementRedirect
}) => {
    return (
        <Card customClassName="flex flex-col w-full  mt-4 items-center justify-center p-6 rounded-lg bg-white shadow-md">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-green-100 mb-4">
                <Check className="h-8 w-8 text-green-600" />
            </div>

            <h2 className="text-2xl font-bold text-gray-800 mb-2">Opération réussie</h2>

            <p className="text-gray-600 text-center mb-6">
                Merci pour votre achat. {orderNumber && (
                    <span>Votre numéro de commande est <strong>{orderNumber}</strong>.</span>
                )}
            </p>

            <div className="w-full border-t border-gray-200 my-4" />

            <div className="flex flex-col sm:flex-row gap-3 w-full justify-center">
                {(invoiceUrl || onDownload) && (
                    <button
                        onClick={onDownload}
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-blue-50 hover:bg-blue-100 text-blue-700 font-medium rounded-md transition-colors"
                    >
                        <Download className="h-5 w-5" />
                        <span>Télécharger la facture</span>
                    </button>
                )}

                {
                    onPrint && (
                        <button
                            onClick={onPrint}
                            className="flex items-center justify-center gap-2 px-4 py-2 bg-amber-100 hover:bg-amber-200 text-amber-800 font-medium rounded-md transition-colors"
                        >
                            <Printer className="h-5 w-5" />
                            <span>Imprimer la facture</span>
                        </button>
                    )}

                <button
                    onClick={onShopRedirect}
                    className="flex items-center justify-center gap-2 px-4 py-2 bg-green-50 hover:bg-green-100 text-green-700 font-medium rounded-md transition-colors"
                >
                    <ShoppingBag className="h-5 w-5" />
                    <span>Continuer les achats</span>
                </button>

                <button
                    onClick={onSellingManagementRedirect}
                    className="flex items-center justify-center gap-2 px-4 py-2 bg-purple-50 hover:bg-purple-100 text-purple-700 font-medium rounded-md transition-colors"
                >
                    <Briefcase className="h-5 w-5" />
                    <span>Gestion des ventes</span>
                </button>
            </div>
        </Card>
    );
};